export default __webpack_public_path__ + "static/media/34.38e44620.png";